import React from 'react'
import { LoaderRow } from 'components/shared/Table/common/LoaderRow/LoaderRow'
import { Pagination } from 'components/shared/Table/common/Pagination/Pagination'
import { useUserDepartmentsTable } from './hooks'
import styles from './UserDepartmentsTable.module.scss'
import { CardTable } from 'components/shared/CardTable/CardTable'
import { CardTableHeader } from 'components/shared/CardTable/CardTableHeader'
import { CardTableHeaderCell } from 'components/shared/CardTable/CardTableHeaderCell'
import { CardTableRow } from 'components/shared/CardTable/CardTableRow'
import { CardTableCell } from 'components/shared/CardTable/CardTableCell'
import { NoDepartments } from './NoDepartments'
import cx from 'classnames'
import { capitalizeFirstLetter } from 'utils/stringFormat'

const mapSortingPropToQueryParam = {
  name: 'name',
}

type UserDepartmentsTableProps = {
  search?: string
  selectedUser: any
  signalTableUpdate?: boolean
  handleDeleteDepartmentAccessOpen: (id: any) => void
}

export const UserDepartmentsTable = ({
  search,
  selectedUser,
  signalTableUpdate,
  handleDeleteDepartmentAccessOpen,
}: UserDepartmentsTableProps) => {
  const {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
      goToProjects,
    },
  } = useUserDepartmentsTable({
    mapSortingPropToQueryParam,
    user: selectedUser?.id,
    signalTableUpdate,
    search,
  })

  if (!isFetching && model.rows?.length === 0) {
    return <NoDepartments selectedUser={selectedUser} />
  }

  return (
    <>
      <CardTable>
        <CardTableHeader>
          {headers.map(({ columnDef }) => {
            const { header, width, alignRight } = columnDef

            return (
              <CardTableHeaderCell
                key={header}
                id={header}
                width={width}
                className={cx({
                  [styles.cardTableHeader]: alignRight,
                })}
              >
                {capitalizeFirstLetter(header)}
              </CardTableHeaderCell>
            )
          })}
        </CardTableHeader>
        {isFetching && <LoaderRow className={styles.loader} />}
        {model.rows.map(({ id, original }) => {
          const { name } = original

          return (
            <CardTableRow
              key={id}
              id={id}
              className={styles.cardTableRow}
              withRemove
              onClick={() => goToProjects(id)}
              deleteRow={rowId => {
                handleDeleteDepartmentAccessOpen(rowId)
              }}
            >
              <CardTableCell className={styles.cardTableCell} width="100%">
                {name}
              </CardTableCell>
            </CardTableRow>
          )
        })}
      </CardTable>
      {/* outside the table: a div is not valid inside <tbody> */}
      {!isFetching && (
        <Pagination
          onSetPage={handlePage}
          onSetPageSize={handlePageSize}
          options={[
            { label: 7, value: 7 },
            { label: 10, value: 10 },
            { label: 15, value: 15 },
          ]}
          {...{ currentPage, pageCount, perPage }}
        />
      )}
    </>
  )
}
